export const OFFLINE_READING_FEATURE_FLAG = 'FTR_OFFLINE_READING';

export const OFFLINE_STORAGE_NAMESPACE = 'offline';
export const OFFLINE_LANGUAGE_STORAGE_KEY = [OFFLINE_STORAGE_NAMESPACE, 'lang'];
